import { render, staticRenderFns } from "./EditUserPermissions.vue?vue&type=template&id=7dd6e724&scoped=true&"
import script from "./EditUserPermissions.vue?vue&type=script&lang=ts&"
export * from "./EditUserPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd6e724",
  null
  
)

export default component.exports